<article [ngClass]="{ 'drawer-open': isDrawerOpen }" class="description">
  @if (productImage) {
    <div class="description__image">
      <mds-image
        [alt]="productImage"
        [border]="false"
        [fill]="true"
        [height]="200"
        [src]="productImage"
        [width]="200"
      ></mds-image>
    </div>
  }
  <div class="description__content">
    @if (isChildPCR) {
      <div class="description__warning-container">
        <mds-alert [type]="'warning'" [text]="warningText"></mds-alert>
      </div>
    }
    @if (actionWarningText) {
      <div class="description__warning-container">
        <mds-alert [type]="'warning'" [text]="actionWarningText"></mds-alert>
      </div>
    }

    <div class="description__header">
      <mds-icon [height]="42" [key]="MdsIcon.NOTES" [width]="42"></mds-icon>
      <h3>Definition</h3>
    </div>
    <ngx-masonry
      (layoutComplete)="reloadMasonryLayout()"
      [options]="{ fitWidth: true }"
      [ordered]="true"
      class="container-masonry"
    >
      @for (info of sectionData; track info; let i = $index) {
        @if (!info.isCardHidden) {
          <div
            [attr.data-index]="i"
            class="description__item"
            [ngClass]="{ 'width-100': data.layer === 'explorer' }"
            ngxMasonryItem
          >
            <app-editable-card
              (reloadCardData)="reloadCardData()"
              [actions]="info.name === forecastSourceName ? forecastSourceActions : actions"
              [data]="info"
              [tab]="data.name"
              [isForecastScenario]="isForecastScenario"
            ></app-editable-card>
          </div>
        }
      }
    </ngx-masonry>
  </div>
  <!--  <div *ngIf="actions.edit && !['Profile','SCIP'].includes(data.name)" class="bulk-actions" >-->
  <!--    <button  mat-fab color="primary" role="button" aria-label="add new" matTooltip="Add more attributes" matTooltipClass="tooltip" (click)="openAttributeModal()">-->
  <!--      <mat-icon aria-hidden="true">add</mat-icon>-->
  <!--    </button>-->
  <!--  </div>-->
</article>
